import { theme } from 'antd';

export const lightThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // Primary colors
    colorPrimary: '#56802d',
    colorPrimaryHover: '#85A65B',
    colorPrimaryActive: '#4A7325',
    colorPrimaryBg: '#F8FAF2',
    colorPrimaryBgHover: '#EEF2E4',
    colorPrimaryBorder: '#B9CC97',
    colorPrimaryBorderHover: '#85A65B',
    colorPrimaryHoverBg: '#EEF2E4',
    colorPrimaryText: '#1C2536',
    colorPrimaryTextActive: '#1C2536',
    colorPrimaryTextHover: '#1C2536',

    // Background colors
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f5f5f5',
    colorBgSpotlight: '#ffffff',
    colorBgMask: 'rgba(0, 0, 0, 0.45)',

    // Text colors
    colorText: '#000000',
    colorTextBase: '#000000',
    colorTextSecondary: '#666666',
    colorTextTertiary: '#999999',
    colorTextQuaternary: '#bfbfbf',
    colorTextPlaceholder: '#C6C8CB',
    colorTextDisabled: '#bfbfbf',
    colorTextLabel: '#727880',
    colorTextDescription: '#666666',

    // Border colors
    colorBorder: '#EEE',
    colorBorderSecondary: '#f0f0f0',
    colorBorderBg: '#ffffff',

    // Fill colors
    colorFill: '#f5f5f5',
    colorFillSecondary: '#fafafa',
    colorFillTertiary: '#f5f5f5',
    colorFillQuaternary: '#f0f0f0',

    // Success colors
    colorSuccess: '#52c41a',
    colorSuccessHover: '#73d13d',
    colorSuccessActive: '#389e0d',
    colorSuccessBg: '#f6ffed',
    colorSuccessBgHover: '#d9f7be',
    colorSuccessBorder: '#b7eb8f',
    colorSuccessBorderHover: '#95de64',

    // Warning colors
    colorWarning: '#faad14',
    colorWarningHover: '#ffc53d',
    colorWarningActive: '#d48806',
    colorWarningBg: '#fffbe6',
    colorWarningBgHover: '#fff1b8',
    colorWarningBorder: '#ffe58f',
    colorWarningBorderHover: '#ffd666',

    // Error colors
    colorError: '#ff4d4f',
    colorErrorHover: '#ff7875',
    colorErrorActive: '#d9363e',
    colorErrorBg: '#fff2f0',
    colorErrorBgHover: '#ffccc7',
    colorErrorBorder: '#ffccc7',
    colorErrorBorderHover: '#ffa39e',

    // Info colors
    colorInfo: '#1890ff',
    colorInfoHover: '#40a9ff',
    colorInfoActive: '#096dd9',
    colorInfoBg: '#e6f7ff',
    colorInfoBgHover: '#bae7ff',
    colorInfoBorder: '#91d5ff',
    colorInfoBorderHover: '#69c0ff',

    // Custom colors for your app
    colorPrimary1: '#4A7325',
    colorPrimaryLight: 'rgba(255, 255, 255, 0.07)',
    colorFillContent: '#F6F6F6',
    colorSelectedTab: '#56802d4d',
    borderRadiusLG: 10,
    buttonColor: '#56802d',
    boxShadowNone: 'none',
    buttonBackgroundColor: '#56802d',

    // Market colors
    marketWatchDown: '#ed4a29',
    marketWatchUp: '#34b622',
    tradeModalBuyColor: '#27611f',

    // Font
    fontFamily: 'Poppins, sans-serif',
  },
  components: {
    Radio: {
      colorPrimary: '#56802d',
    },
    Checkbox: {
      colorPrimary: '#A5CB1C',
      colorPrimaryHover: '#A5CB1C',
      colorBgLightGrey: '#F5F5F5',
    },
    Card: {
      colorBgContainer: '#ffffff',
      colorBorderSecondary: '#f0f0f0',
    },
    Table: {
      colorBgContainer: '#ffffff',
      colorFillAlter: '#fafafa',
      colorBorderSecondary: '#f0f0f0',
    },
    Modal: {
      colorBgElevated: '#ffffff',
      colorBgMask: 'rgba(0, 0, 0, 0.45)',
    },
    Drawer: {
      colorBgElevated: '#ffffff',
    },
    Menu: {
      colorItemBg: '#ffffff',
      colorSubItemBg: '#fafafa',
      colorItemBgSelected: '#56802d',
      colorItemBgHover: '#f5f5f5',
    },
    Layout: {
      colorBgHeader: '#ffffff',
      colorBgSider: '#ffffff',
      colorBgTrigger: '#f5f5f5',
    },
    Input: {
      colorBgContainer: '#ffffff',
      colorBorder: '#d9d9d9',
      colorTextPlaceholder: '#bfbfbf',
    },
    Select: {
      colorBgContainer: '#ffffff',
      colorBorder: '#d9d9d9',
    },
    Button: {
      colorBgContainer: '#ffffff',
      colorBorder: '#d9d9d9',
    },
    Tooltip: {
      colorBgSpotlight: '#1E293B',
      colorTextLightSolid: '#ffffff',
    },
  },
}; 